import axios from "./api";

export const getMembers = async () => {
  try {
    const response = await axios.get("/members");
    return response.data;
  } catch (err) {
    console.log("err", err);
    return err;
  }
};

export const checkInMember = async (member) => {
  // Call check in API here.

  try {
    const response = await axios.post("/checkin", { member: member.PK });
    //console.log(`Response ${response}`);
    //console.log(`Checked in ${member.PK}`);
    return response.data;
  } catch (err) {
    console.log("err", err);
    return err;
  }
};

export const listCheckins = async (member) => {
  // Call check in API here.

  try {
    const response = await axios.get("/checkin",{params: { id: member.PK }});
    //console.log(`Response ${response}`);
    //console.log(`Checked in ${member.PK}`);
    return response.data;
  } catch (err) {
    console.log("err", err);
    return err;
  }
};

export const listAllCheckins = async () => {
  try {
    const response = await axios.get("/checkin");
    return response.data;
  } catch (err) {
    console.log("err", err);
    return [];
  }
};

export const listGuests = async () => {
  try {
    const response = await axios.get("/guest");
    return response.data;
  } catch (err) {
    console.log("err", err);
    return [];
  }
};

export const getMemberChanges = async (year) => {
  try {
    const response = await axios.get("/members", { params: { changes: year } });
    return response.data;
  } catch (err) {
    console.log("err", err);
    return [];
  }
};

export const logGuest = async ({ guestName, cellEmail, partySize, paymentMethod, memberPK }) => {
  try {
    const response = await axios.post("/guest", {
      name: guestName,
      cellEmail,
      member: memberPK,
      guestCount: partySize,
      payment: paymentMethod,
    });
    return response.data;
  } catch (err) {
    console.log("err", err);
    return err;
  }
};

